<template>
  <div>
    <!-- HOME -->
    <section class="home">
      <div class="container pt-5 mt-5">
        <div class="row" dir="rtl">
          <div class="col-lg-6 col-12 d-flex align-items-center justify-content-center">
            <div class="text-lg-left text-center">
              <h1 class="mb-4 mt-3">تطبيق سلتك</h1>
              <p class="mb-5">
                يساعدك على متابعة أفضل أسعار وخصومات المنتجات
                <br />في جميع أنحاء المملكة
              </p>
              <div class="d-inline-block">
                <a href="https://apps.apple.com/us/app/id1529797452" target="_blank">
                  <img
                    class="download-app-btn"
                    src="assets/images/app-store.svg"
                    alt="download on app store"
                  />
                </a>
              </div>
              <div class="d-inline-block mx-2">
                <a href="https://play.google.com/store/apps/details?id=com.alexapps.salatak" target="_blank">
                  <img
                    class="download-app-btn"
                    src="assets/images/google-play.png"
                    alt="download on google-play"
                  />
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12 mt-5 mt-lg-0 text-center">
            <img class="home-image" src="assets/images/home1.png" alt="home" />
            <img class="home-image back" src="assets/images/home2.png" alt="home" />
          </div>
        </div>
      </div>
    </section>

    <svg>
      <clipPath id="wave" clipPathUnits="objectBoundingBox">
        <path class="st0" d="M1,0c0,0-0.3,0.2-0.5,0.1S0.3,0,0,0.1V1h1L1,0z" />
      </clipPath>
    </svg>

    <!-- ABOUT -->
    <section id="about" class="section about light">
      <div class="container px-md-5">
        <div class="row">
          <div class="col-lg-5 col-12">
            <div class="pr-md-5 text-center">
              <img class="about-image" src="assets/images/shoping_1.svg" alt="About" />
            </div>
          </div>
          <div class="col-lg-7 col-12 mt-5 mt-md-0">
            <div class="pl-md-5 pr-md-4">
              <h2 class="mb-5 mt-md-5">عن التطبيق</h2>
              <ul class="list-unstyled pr-0 pl-0">
                <li>
                  تسوق أون لاين من بين أكثر المنتجات جودة
                  <i class="mr-3 fa fa-angle-left"></i>
                </li>
                <li>
                  شاهد أفضل الأسعار الموجودة في جميع المتاجر بالمملكة
                  <i
                    class="mr-3 fa fa-angle-left"
                  ></i>
                </li>
                <li>
                  اطبع فاتورة بالمنتجات أو أرسلها الي تطبيقاتك المفضلة
                  <i
                    class="mr-3 fa fa-angle-left"
                  ></i>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- FEATURE -->
    <section id="features" class="section features light">
      <div class="container px-md-5">
        <h2 class="text-center mb-5">المميزات</h2>
        <div class="row pt-4" dir="rtl">
          <div class="col-md-4 col-12 feature text-center">
            <img src="assets/images/feature_1.png" alt="img" class="img-fluid" />
            <h4 class="light mt-4">المنتجات</h4>
            <p class="separator" style="color: #888888;">تسوق من بين أجود وأفضل المنتجات.</p>
          </div>
          <div class="col-md-4 col-12 feature middle text-center">
            <img src="assets/images/feature_2.png" alt="img" class="img-fluid" />
            <h4 class="light mt-4">العروض</h4>
            <p class="separator" style="color: #888888;">أحصل علي أفضل العروض والتخفيضات.</p>
          </div>
          <div class="col-md-4 col-12 feature text-center">
            <img src="assets/images/feature_3.png" alt="img" class="img-fluid" />
            <h4 class="light mt-4">المتاجر</h4>
            <p class="separator" style="color: #888888;">تسوق من بين أفضل المتاجر في المملكة.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- SCREENS -->
    <section id="screens" class="section screenshoots light down-curve">
      <div class="container">
        <h2 class="text-center">صور من التطبيق</h2>

        <div class="screens-stage mt-5">
          <div class="screen text-center">
            <img
              class="mobile-view"
              style="display: inline"
              src="assets/images/screens/1.png"
              alt="screen"
            />
          </div>
          <div class="screen text-center">
            <img
              class="mobile-view"
              style="display: inline"
              src="assets/images/screens/2.png"
              alt="screen"
            />
          </div>
          <div class="screen text-center">
            <img
              class="mobile-view"
              style="display: inline"
              src="assets/images/screens/3.png"
              alt="screen"
            />
          </div>
          <div class="screen text-center">
            <img
              class="mobile-view"
              style="display: inline"
              src="assets/images/screens/4.png"
              alt="screen"
            />
          </div>
          <div class="screen text-center">
            <img
              class="mobile-view"
              style="display: inline"
              src="assets/images/screens/5.png"
              alt="screen"
            />
          </div>
          <div class="screen text-center">
            <img
              class="mobile-view"
              style="display: inline"
              src="assets/images/screens/4.png"
              alt="screen"
            />
          </div>
          <div class="screen text-center">
            <img
              class="mobile-view"
              style="display: inline"
              src="assets/images/screens/5.png"
              alt="screen"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
export default {
  name: "home-page",

  mounted() {
    var screensStage = $(".screens-stage");

    screensStage.slick({
      centerPadding: "0.7em",
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            centerPadding: "0.4em",
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
            centerPadding: "0",
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            centerPadding: "40px",
            slidesToShow: 1,
          },
        },
      ],
    });
  },
};
</script>